import { render, staticRenderFns } from "./LKRoadmapsFeedCardEventUp.vue?vue&type=template&id=7940aac0&"
import script from "./LKRoadmapsFeedCardEventUp.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedCardEventUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports